import { createSlice } from "@reduxjs/toolkit";

const initialHomeState = {
  dailyPointsInformation: {
    data: [],
    loading: false,
  },
  kpiEntries: {
    data: [],
    targetPoints: 10,
    lastUpdated: "",
    loading: false,
    initialLoading: false,
    outOfOfficeDays: [],
    outOfOfficeDayUpdated: 0,
  },
  myTeam: {
    data: [],
    loading: false,
  },
  refetchCompetitions: 0,
  leaderboardWidgets: {
    refresh: 0,
    kpiActionId: 0,
  },
  kpiWidgets: {
    refresh: 0,
    kpiActionId: 0,
  },
  weeklyTotals: {
    data: [],
    loading: false,
    initialLoadComplete: false,
  },
  achievements: {
    loading: false,
    pointGoals: [],
    activeStreak: 0,
    refresh: 0,
  },
  celebration: {
    latestCelebrationDate: null,
    soundEnabled: true,
  },
  notifications: {
    notifications: [],
    loading: false,
  },
};

const home = createSlice({
  name: "home",
  initialState: initialHomeState,
  reducers: {
    getDailyPointsInfoSaga(state) {
      state.dailyPointsInformation.loading = true;
    },
    getDailyPointsInfo(state, action) {
      state.dailyPointsInformation.data = action.payload.data;
      state.dailyPointsInformation.loading = false;
    },
    getDailyPointsInfoFail(state) {
      state.dailyPointsInformation.loading = false;
    },
    getKpiEntrySaga(state) {
      state.kpiEntries.initialLoading = true;
    },
    setLastUpdatedTimestamp(state, action) {
      state.kpiEntries.lastUpdated = action.payload;
    },
    getKpiEntry(state, action) {
      state.kpiEntries.data =
        action.payload.data?.sort((a, b) => {
          if (!a?.sortByOrder && b?.sortByOrder) return 1;
          if (a?.sortByOrder && !b?.sortByOrder) return -1;
          return a.sortByOrder - b.sortByOrder;
        }) || [];
      state.kpiEntries.lastUpdated = action.payload.lastUpdated;
      state.kpiEntries.targetPoints = action.payload.targetPoints;
      state.kpiEntries.initialLoading = false;
      state.kpiEntries.loading = false;
      state.kpiEntries.outOfOfficeDays = action.payload.outOfOfficeDays || [];
      state.achievements.pointGoals = action.payload.pointGoals;
      state.achievements.activeStreak = action.payload.activeStreak;
    },
    getKpiEntryFail(state) {
      state.kpiEntries.initialLoading = false;
      state.kpiEntries.loading = false;
    },
    updateKpiEntrySaga(state, action) {
      const { updatedActionData: payload } = action.payload;
      if (payload.call) {
        state.kpiEntries.loading = true;
      }
      const tempKpiEntries = [...state.kpiEntries.data];
      const kpiIndex = tempKpiEntries.findIndex((kpi) => kpi.kpiActionId === payload.kpiActionId);
      if (kpiIndex !== -1) {
        if (!payload.call && typeof tempKpiEntries?.[kpiIndex]?.prevCount === "undefined") {
          tempKpiEntries[kpiIndex].prevCount = tempKpiEntries[kpiIndex].DailyActions[0].count;
        }
        tempKpiEntries[kpiIndex].DailyActions[0].count = payload?.count;
        tempKpiEntries[kpiIndex].disabled = payload?.disabled;
      }

      state.kpiEntries.data =
        tempKpiEntries?.sort((a, b) => {
          if (!a?.sortByOrder && b?.sortByOrder) return 1;
          if (a?.sortByOrder && !b?.sortByOrder) return -1;
          return a.sortByOrder - b.sortByOrder;
        }) || [];
    },
    updateKpiActivityBeforeAPICall(state, action) {
      if (!action.payload.call) {
        state.kpiEntries.loading = true;
      }
      const tempKpiEntries = [...state.kpiEntries.data];
      const kpiIndex = tempKpiEntries.findIndex(
        (kpi) => kpi.kpiActionId === action.payload.kpiActionId
      );
      if (kpiIndex !== -1) {
        if (!action.payload.call && typeof tempKpiEntries?.[kpiIndex]?.prevCount === "undefined") {
          tempKpiEntries[kpiIndex].prevCount = tempKpiEntries[kpiIndex].DailyActions[0].count;
        }
        tempKpiEntries[kpiIndex].DailyActions[0].count = action.payload?.count;
        tempKpiEntries[kpiIndex].disabled = action.payload?.disabled;
      }

      state.kpiEntries.data =
        tempKpiEntries?.sort((a, b) => {
          if (!a?.sortByOrder && b?.sortByOrder) return 1;
          if (a?.sortByOrder && !b?.sortByOrder) return -1;
          return a.sortByOrder - b.sortByOrder;
        }) || [];
    },
    updateKpiEntry(state, action) {
      const tempKpiEntries = [...state.kpiEntries.data];
      const kpiIndex = tempKpiEntries.findIndex(
        (kpi) => kpi.kpiActionId === action.payload.info.kpiActionId
      );
      if (kpiIndex !== -1) {
        tempKpiEntries[kpiIndex].DailyActions[0].points = parseInt(
          action?.payload?.info?.points,
          10
        );
        tempKpiEntries[kpiIndex].disabled = false;
        if (typeof tempKpiEntries?.[kpiIndex]?.prevCount !== "undefined") {
          delete tempKpiEntries[kpiIndex].prevCount;
        }
      }
      state.kpiEntries.loading = false;
      state.kpiEntries.data =
        tempKpiEntries?.sort((a, b) => {
          if (!a?.sortByOrder && b?.sortByOrder) return 1;
          if (a?.sortByOrder && !b?.sortByOrder) return -1;
          return a.sortByOrder - b.sortByOrder;
        }) || [];
    },
    updateKpiEntryFail(state, action) {
      const tempKpiEntries = [...state.kpiEntries.data];
      const kpiIndex = tempKpiEntries.findIndex(
        (kpi) => kpi.kpiActionId === action.payload.kpiActionId
      );
      if (kpiIndex !== -1) {
        tempKpiEntries[kpiIndex].DailyActions[0].count = tempKpiEntries[kpiIndex].prevCount;
        tempKpiEntries[kpiIndex].disabled = false;
      }
      state.kpiEntries.loading = false;
    },
    updateKpiEntryDisabled(state, action) {
      const tempKpiEntries = [...state.kpiEntries.data];
      const kpiIndex = tempKpiEntries.findIndex(
        (kpi) => kpi.kpiActionId === action.payload.kpiActionId
      );
      if (kpiIndex !== -1) {
        tempKpiEntries[kpiIndex].disabled = action.payload.disabled;
      }
    },
    updateSortByOrderOfKpiSaga(state) {
      state.kpiEntries.loading = true;
    },
    handleSortByOrderOfKpiSuccess(state, action) {
      const tempKpiEntries = [...state.kpiEntries.data];
      state.kpiEntries.data =
        tempKpiEntries
          .map((kpiEntry) => {
            const matchedKpiEntry = action.payload.data.find((kpi) => kpi.id === kpiEntry.id);
            if (matchedKpiEntry) kpiEntry.sortByOrder = matchedKpiEntry.sortByOrder;
            return kpiEntry;
          })
          ?.sort((a, b) => {
            if (!a?.sortByOrder && b?.sortByOrder) return 1;
            if (a?.sortByOrder && !b?.sortByOrder) return -1;
            return a.sortByOrder - b.sortByOrder;
          }) || [];
      state.kpiEntries.loading = false;
    },
    handleSortByOrderOfKpiFail(state) {
      state.kpiEntries.loading = false;
    },

    getMyTeamDataSaga(state) {
      state.myTeam.loading = true;
    },
    getMyTeamData(state, action) {
      state.myTeam.data = action.payload.data;
      state.myTeam.loading = false;
    },
    getMyTeamDataFail(state) {
      state.myTeam.loading = false;
    },
    refetchCompetitions(state) {
      state.refetchCompetitions += 1;
    },
    refreshLeaderboardWidgets(state, action) {
      state.leaderboardWidgets.refresh += 1;
      state.leaderboardWidgets.kpiActionId = action.payload.kpiActionId;
    },
    refreshKpiWidgets(state, action) {
      state.kpiWidgets.refresh += 1;
      state.kpiWidgets.kpiActionId = action.payload.kpiActionId;
    },
    refreshAchievements(state) {
      state.achievements.refresh += 1;
    },
    getWeeklyTotalsRequest(state) {
      state.weeklyTotals.loading = true;
    },
    getWeeklyTotalsSuccess(state, action) {
      state.weeklyTotals.data = action.payload.data || [];
      state.weeklyTotals.loading = false;
      state.weeklyTotals.initialLoadComplete = true;
    },
    getWeeklyTotalsFailed(state) {
      state.weeklyTotals.loading = false;
      state.weeklyTotals.initialLoadComplete = true;
    },
    getUserAchievements(state) {
      state.achievements.loading = true;
    },
    getUserAchievementsSuccess(state, action) {
      state.achievements.pointGoals = action.payload.pointGoals;
      state.achievements.activeStreak = action.payload.activeStreak;
    },
    getUserAchievementsFailure(state) {
      state.achievements.loading = false;
    },
    updateCelebrationDate(state, action) {
      const { celebrationDate } = action.payload;
      state.celebration.latestCelebrationDate = celebrationDate;
    },
    getCelebrationDetailsAction() {},
    getCelebrationDetailsRetrieved(state, action) {
      const { celebrationDate, soundEnabled } = action.payload;
      state.celebration.latestCelebrationDate = celebrationDate;
      state.celebration.soundEnabled = soundEnabled;
    },
    updateSoundEnabled(state, action) {
      const { soundEnabled } = action.payload;
      state.celebration.soundEnabled = soundEnabled;
    },
    outOfOfficeDayUpdated(state) {
      state.kpiEntries.outOfOfficeDayUpdated += 1;
    },
    fetchNotificationsSaga(state) {
      state.notifications.loading = true;
    },
    setNotifications(state, action) {
      state.notifications.notifications = action.payload;
    },
    fetchNotificationsFinished(state) {
      state.notifications.loading = false;
    },
    clearNotificationsSaga(state) {
      state.notifications.notifications = [];
    },
    setSeenNotificationSaga(state, action) {
      const id = action.payload;
      if (id) {
        state.notifications.notifications = state.notifications.notifications.filter(
          (notification) => notification.id !== id
        );
      }
    },
    clearNotificationsForWinWireMessage(state, action) {
      const { messageId } = action.payload;
      state.notifications.notifications = state.notifications.notifications.filter(
        (notification) => {
          // A typical notification key looks like "winwire-<messageId>-<replyId>-tagged-<userId>"
          const keyParts = notification.key.split("-");

          if (keyParts.length >= 2 && keyParts[0] === "winwire") {
            const keyMessageId = +keyParts[1];
            return keyMessageId !== messageId; // Keep notifications that don't match the messageId
          }

          return true;
        }
      );
    },
    newNotification(state, action) {
      // Receive notification over websocket
      state.notifications.notifications.unshift(action.payload);
    },
  },
});
export const homeAction = home.actions;
export default home.reducer;
